import { useMutation } from '@tanstack/react-query';
import { authConfig } from '@/libs/auth-config';
import api from '@/libs/axiosInstance';
import { tokenManager } from '@/libs/token-manager';

const logoutRequest = async (): Promise<void> => {
  console.log('[Logout] Submitting logout request...');

  try {
    await api.post(authConfig.endpoints.logout);
    console.log('[Logout] Logout API call successful');
  } catch (error) {
    console.error('[Logout] Logout process failed:', error);
    throw error;
  } finally {
    // Always clear tokens from token manager, even if API call fails
    tokenManager.clearTokens();
    console.log('[Logout] Tokens cleared from token manager');
  }
};

export const useLogoutAction = () =>
  useMutation<void, Error, void>({
    mutationFn: logoutRequest,
  });
